export default "__VITE_ASSET__Cemeeue2__"